///////////////////////////////////////////////////////////////////////////////
import Helper from '../helper/helper'
import leftMenuVdsina from './admin-left-menu-vdsina'
import leftMenuVdsinaCom from './admin-left-menu-vdsina-com'
import leftMenuMacloud from './admin-left-menu-macloud'

const leftMenu = () => {
	if (process.env.APP_NAME === 'macloud') return leftMenuMacloud
	if (process.env.APP_NAME === 'vdsina.com') return leftMenuVdsinaCom
	return leftMenuVdsina
}

///////////////////////////////////////////////////////////////////////////////
const adminData = {
	//=========================================================================
	// левое меню
	//=========================================================================
	leftMenu: leftMenu(),

	//=========================================================================
	// VDS
	//=========================================================================
	'vds': {
		'model': 'ServiceSearch',
		'list': {
			'buttons': {
				'bulkDel': 'service_name',
				'create': 'service/create_vds',
				'off': 'service_name',
				'on': 'service_name',
				'migrate': 'service_name',
				'serviceMove': 'service_name'
			},
			'on-off': 'services',
			'column_id': 'service_id',
			'filters': {
				'radio': {
					// записывается в формате: field_name: title
					'service_status': 'main/status',
					'plan_group_id': 'plangroup/plangroup'
				},
				'select': {
					'plan_id': 'plan/plan',
					'datacenter_id': 'datacenter/datacenter',
					'template_id': 'template/template',
					'ip_net': 'ippool/view_net',
					'server_group_id': 'servergroup/servergroup',
					'server_view_type': 'server/server'
				},
				'planParams': {
				},
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				}
			},
			'columns': {
				'service_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 70px',
					'class-row': 'text-right'
				},
				'group': {
					'class-row': 'text-center vertical-align-middle',
					'class-col': 'aw5-vds-column-os text-center',
					'title': 'main/type',
					'component-row': 'imageGroupVds',
					'component-param-title': (row, data) => Helper.vdsGroupImageTitle(row, data),
					'component-param-url': (row) => Helper.vdsGroupImage(row)
				},
				'os': {
					'title': 'template/os',
					'class-row': 'text-center vertical-align-middle',
					'class-col': 'aw5-vds-column-os text-center',
					'component-row': 'image',
					'component-param-url': (row) => Helper.cellValueFromServiceData('template:image', row)
				},
				'vds': {
					'title': 'service/service',
					'class-col': 'aw5-vds-column-vds',
					'component-row': 'vds_info',
					'component-param-data': (row) => Helper.cellValueFromServiceData('plan:data', row),
					'component-param-flag': (row) => Helper.cellValueFromServiceData('datacenter:country', row),
					'component-param-flag-name': (row) => Helper.cellValueFromServiceData('datacenter:name', row),
					'component-param-url': (row) => '/vds/view/' + row['service_id'],
					'component-param-statusService': (row) => row['service_status'],
					'component-param-statusServiceText': (row) => row['service_status_text'],
					'component-param-text': (row) => row['service_name']
				},
				'ip': {
					'title': 'ippool/ippool',
					'class-col': 'aw5-vds-column-ip',
					'function-row': (row) => Helper.cellValueFromServiceData('ip:ip', row),
					'function-cell-class': (row) => {
						return Helper.cellValueFromServiceData('ip:ip:active', row) ? '' : 'text-strike'
					}
				},
				'service_status': {
					'sort': true,
					'class-col': 'aw5-vds-column-status',
					'component-row': 'status_info',
					'function-row': (row, raw) => Helper.cellStatus('service_status', row, raw),
					'function-cell-class': (row) => 'w5-status-color-' + row['service_status']
				},
				'service_created': {
					'sort': true,
					'class-col': 'text-center aw5-vds-column-created',
					'class-row': 'text-center vds-date',
					'formater-row': 'formater_StrDateOnly'
				},
				'server_name': {
					'sort': true,
					'class-col': 'aw5-vds-column-server'
				},
				'account_name': {
					'sort': true,
					'class-col': 'aw5-vds-column-account',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.account_id ? '/account/view/' + row.account_id : ''
				}
			},
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				},
				'note': {
					'title': 'notes/notes',
					'action': 'func:GoTo:notes:service:note_object'
				},
				'createNote': {
					'title': 'notes/create_note',
					'action': 'func:createNoteFromMenu'
				},
				'request': {
					'title': 'request/title',
					'action': 'func:GoTo:request::service_id'
				},
				'vdsReboot': {
					'title': 'service/reboot',
					'action': 'func:GoToVds:reboot'
				},
				'vdsPlan': {
					'title': 'service/plan_change',
					'action': 'func:GoToVds:plan'
				},
				'vdsReinstall': {
					'title': 'service/reinstall',
					'action': 'func:GoToVds:reinstall'
				},
				'vdsChangePassword': {
					'title': 'service/password_change',
					'action': 'func:GoToVds:password'
				},
				'prolong': {
					'title': 'service/prolong',
					'action': 'func:prolongService'
				},
				'removeFilter': {
					'title': 'service/remove_filter',
					'action': 'func:removeFilter'
				},
				'vdsClone': {
					'title': 'main/clone',
					'action': 'func:vdsClone'
				},
				'clientTicket': {
					'title': 'ticket/write',
					'action': 'func:clientTicket'
				}
			}
		},
		'hint-link': {
			'create': [
				{
					position: 'before-button',
					title: 'field/hint_ssh_key_before',
					link: process.env.QA_SERVER + '/q/autentifikatsiya-s-pomoshchyu-ssh-klyuchey-i-otklyuchenie-dostupa-po-parolyu',
					afterText: 'field/hint_ssh_key_after',
					showIfField: 'sshkey_id'
				},
				{
					position: 'before-button',
					title: 'field/hint_backup_auto',
					link: process.env.QA_SERVER + '/q/kak-nastroit-rezervnoe-kopirovanie-po-raspisaniyu',
					showIfField: 'backup_auto'
				}
			]
		}
	},

	//=========================================================================
	// DISKS
	//=========================================================================
	'disks': {
		'model': 'ServiceSearch',
		'list': {
			'buttons': {
				'bulkDel': 'service_name',
				'create': 'service/extdisk_create',
				'off': 'service_name',
				'on': 'service_name',
				'serviceMove': 'service_name'
			},
			'on-off': 'services',
			'column_id': 'service_id',
			'filters': {
				'radio': {
					// записывается в формате: field_name: title
					'service_status': 'main/status'
				},
				'select': {
					'datacenter_id': 'datacenter/datacenter'
				},
				'diskType': {
					'service_type_id': 'servicetype/servicetype'
				},
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				}
			},
			'columns': {
				'service_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 70px',
					'class-row': 'text-right'
				},
				'service_name': {
					'title': 'service/extdisk',
					'class-col': 'aw5-vds-column-vds',
					'component-row': 'backup_name',
					'component-param-flag': (row) => Helper.cellValueFromServiceData('datacenter:country', row),
					'component-param-flag-name': (row) => Helper.cellValueFromServiceData('datacenter:name', row),
					'component-param-url': (row) => `/disks/${row['service_status'] === 'active' ? 'update' : 'view'}/` + row['service_id'],
					'component-param-statusService': (row) => row['service_status'],
					'component-param-statusServiceText': (row) => row['service_status_text'],
					'component-param-text': (row) => row['service_name_full']
				},
				'attached': {
					'title': 'service/extdisk_attached',
					'component-row': 'outer_disk_info'
				},
				'service_status': {
					'sort': true,
					'style-col': 'width: 115px',
					'component-row': 'status_info',
					'function-row': (row, raw) => Helper.cellStatus('service_status', row, raw),
					'function-cell-class': (row) => 'w5-status-color-' + row['service_status']
				},
				'service_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.account_id ? '/account/view/' + row.account_id : ''
				}
			},
			'opers': {
				'update': {
					'action': 'url:/disks/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name_full',
						'timer': 5
					}
				},
				'connectOuterDisk': {
					'title': 'main/attach main/disk',
					'action': 'func:connectOuterDisk'
				},
				'ejectOuterDisk': {
					'title': 'main/detach main/disk',
					'action': 'func:ejectOuterDisk'
				},
				'cloneOuterDisk': {
					'title': 'main/clone',
					'action': 'func:cloneOuterDisk'
				},
				'backupOuterDisk': {
					'title': 'service/backup_create',
					'action': 'func:backupOuterDisk'
				},
				'restoreBackupOuterDisk': {
					'title': 'service/backup_restore',
					'action': 'func:restoreBackupOuterDisk'
				},
				'note': {
					'title': 'notes/notes',
					'action': 'func:GoTo:notes:service:note_object'
				},
				'createNote': {
					'title': 'notes/create_note',
					'action': 'func:createNoteFromMenu'
				},
				'scheduleOuterDisk': {
					'title': 'schedule/create_title',
					'action': 'func:scheduleOuterDisk'
				},
				'scheduleOuterDiskUpdate': {
					'title': 'schedule/update_title',
					'action': 'func:scheduleOuterDisk'
				},
				'request': {
					'title': 'request/title',
					'action': 'func:GoTo:request::service_id'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				},
				'prolong': {
					'title': 'service/prolong',
					'action': 'func:prolongService'
				}
			}
		},
		'hint-link': {
			'create': [
				{
					position: 'before-button',
					title: 'field/hint_backup_auto',
					link: process.env.QA_SERVER + '/q/kak-nastroit-rezervnoe-kopirovanie-po-raspisaniyu',
					showIfField: 'backup_auto'
				}
			]
		}
	},

	//=========================================================================
	// BACKUPS
	//=========================================================================
	'backups': {
		'model': 'ServiceSearch',
		'list': {
			'buttons': {
				'bulkDel': 'service_name',
				'create': 'service/backup_create',
				'off': 'service_name',
				'on': 'service_name',
				'serviceMove': 'service_name'
			},
			'on-off': 'services',
			'column_id': 'service_id',
			'filters': {
				'radio': {
					// записывается в формате: field_name: title
					'service_status': 'main/status'
				},
				'select': {
					'datacenter_id': 'datacenter/datacenter',
					'server_view_type': 'server/server'
				},
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				}
			},
			'columns': {
				'service_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 70px',
					'class-row': 'text-right'
				},
				'backup_name': {
					'title': 'service/backup',
					'class-col': 'aw5-vds-column-vds',
					'component-row': 'backup_name',
					'component-param-flag': (row) => Helper.cellValueFromServiceData('datacenter:country', row),
					'component-param-flag-name': (row) => Helper.cellValueFromServiceData('datacenter:name', row),
					'component-param-url': (row) => '/backups/view/' + row['service_id'],
					'component-param-statusService': (row) => row['service_status'],
					'component-param-statusServiceText': (row) => row['service_status_text'],
					'component-param-text': (row) => row['service_name_full']
				},
				'service_status': {
					'sort': true,
					'style-col': 'width: 115px',
					'component-row': 'status_info',
					'function-row': (row, raw) => Helper.cellStatus('service_status', row, raw),
					'function-cell-class': (row) => 'w5-status-color-' + row['service_status']
				},
				'service_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				},
				'server_name': {
					'sort': true,
					'class-col': 'aw5-vds-column-server'
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.account_id ? '/account/view/' + row.account_id : ''
				}
			},
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name_full',
						'timer': 5
					}
				},
				'note': {
					'title': 'notes/notes',
					'action': 'func:GoTo:notes:service:note_object'
				},
				'createNote': {
					'title': 'notes/create_note',
					'action': 'func:createNoteFromMenu'
				},
				'request': {
					'title': 'request/title',
					'action': 'func:GoTo:request::service_id'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				},
				'restoreBackup': {
					'title': 'main/restore',
					'action': 'func:restoreBackup'
				},
				'createFromBackup': {
					'title': 'main/create server/server',
					'action': 'func:createFromBackup'
				},
				'createFromBackupOuterDisk': {
					'title': 'service/extdisk_create',
					'action': 'func:createFromBackupOuterDisk'
				},
				'renameBackup': {
					'title': 'service/rename_action',
					'action': 'func:renameBackup'
				},
				'clientTicket': {
					'title': 'ticket/write',
					'action': 'func:clientTicket'
				},
				'copyToDc': {
					'title': 'main/copy',
					'action': 'func:copyToDc'
				},
				'downloadBackup': {
					'title': 'backup/download_title',
					'action': 'func:downloadBackup'
				}
			}
		}
	},

	//=========================================================================
	// SSHKEY
	//=========================================================================
	'sshkey': {
		'model': 'SshKeySearch',
		'list': {
			'can_select_rows': false,
			'buttons': {
				// формат: тип => заголовок
				'create': 'sshkey/create_title'
			},
			'column_id': 'key_id',
			'columns': {
				'key_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.key_id ? '/sshkey/view/' + row.key_id : ''
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.account_id ? '/account/view/' + row.account_id : ''
				}
			},
			'opers': {
				'update': {
					'action': 'url:/sshkey/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'key_name'
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:sshkey:log_sub'
				},
				'clientTicket': {
					'title': 'ticket/write',
					'action': 'func:clientTicket'
				}
			}
		}
	},

	//=========================================================================
	// ISO
	//=========================================================================
	'iso': {
		'model': 'ServiceSearch',
		'list': {
			'buttons': {
				'bulkDel': 'service_name',
				'create': 'service/iso_create',
				'off': 'service_name',
				'on': 'service_name',
				'serviceMove': 'service_name'
			},
			'on-off': 'services',
			'column_id': 'service_id',
			'filters': {
				'radio': {
					// записывается в формате: field_name: title
					'service_status': 'main/status'
				},
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				}
			},
			'columns': {
				'service_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 70px',
					'class-row': 'text-right'
				},
				'service_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.service_id ? '/iso/view/' + row.service_id : ''
				},
				'attached': {
					'style-col': 'width: 170px',
					'title': 'service/iso_inserting_data',
					'component-row': 'iso_info'
				},
				'size': {
					'style-col': 'width: 85px',
					'title': 'service/iso_size',
					'function-row': (row, raw) => {
						if (row && row['service_data'] && row['service_data']['iso'] && row['service_data']['iso']['filesize'])
							return row['service_data']['iso']['filesize']
						else
							return 'main/unknown'
					}
				},
				'service_status': {
					'sort': true,
					'style-col': 'width: 115px',
					'component-row': 'status_info',
					'function-row': (row, raw) => Helper.cellStatus('service_status', row, raw),
					'function-cell-class': (row) => 'w5-status-color-' + row['service_status']
				},
				'service_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.account_id ? '/account/view/' + row.account_id : ''
				}
			},
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name',
						'timer': 5
					}
				},
				'connectISOOper': {
					'title': 'service/iso_insert',
					'action': 'func:connectISOOper'
				},
				'ejectISOOper': {
					'title': 'service/iso_eject',
					'action': 'func:ejectISOOper'
				},
				'note': {
					'title': 'notes/notes',
					'action': 'func:GoTo:notes:service:note_object'
				},
				'createNote': {
					'title': 'notes/create_note',
					'action': 'func:createNoteFromMenu'
				},
				'request': {
					'title': 'request/title',
					'action': 'func:GoTo:request::service_id'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				},
				'prolong': {
					'title': 'service/prolong',
					'action': 'func:prolongService'
				},
				'clientTicket': {
					'title': 'ticket/write',
					'action': 'func:clientTicket'
				}
			}
		}
	},

	//=========================================================================
	// ADDITIONAL-SERVICES
	//=========================================================================
	'additional-services': {
		'model': 'ServiceSearch',
		'list': {
			'buttons': {
				'bulkDel': 'service_name',
				'off': 'service_name',
				'on': 'service_name'
			},
			'on-off': 'services',
			'column_id': 'service_id',
			'filters': {
				'radio': {
					// записывается в формате: field_name: title
					'service_status': 'main/status'
				},
				'select': {
					//'ip_net': 'ippool/view_net',
					'service_type_id': 'servicetype/servicetype'
				},
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				}
			},
			'columns': {
				'service_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 70px',
					'class-row': 'text-right'
				},
				'service_name_full': {
					'title': 'service/service',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.service_id ? '/additional-services/view/' + row.service_id : ''
				},
				'parent_name': {
					'title': 'service/parent',
					'sort': true,
					'style-col': 'width: 200px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.parent_id ? '/service/view/' + row.parent_id : ''
				},
				'service_status': {
					'sort': true,
					'style-col': 'width: 115px',
					'component-row': 'status_info',
					'function-row': (row, raw) => Helper.cellStatus('service_status', row, raw),
					'function-cell-class': (row) => 'w5-status-color-' + row['service_status']
				},
				'service_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.account_id ? '/account/view/' + row.account_id : ''
				}
			},
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name_full',
						'timer': 5
					}
				},
				'note': {
					'title': 'notes/notes',
					'action': 'func:GoTo:notes:service:note_object'
				},
				'createNote': {
					'title': 'notes/create_note',
					'action': 'func:createNoteFromMenu'
				},
				'request': {
					'title': 'request/title',
					'action': 'func:GoTo:request::service_id'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				},
				'prolong': {
					'title': 'service/prolong',
					'action': 'func:prolongService'
				},
				'clientTicket': {
					'title': 'ticket/write',
					'action': 'func:clientTicket'
				}
			}
		}
	},

	//=========================================================================
	// CERTIFICATE
	//=========================================================================
	'certificate': {
		'model': 'ServiceSearch',
		'list': {
			'buttons': {
				'bulkDel': 'service_name',
				//'create': 'service/cert_create',
				'off': 'service_name',
				'on': 'service_name',
				'serviceMove': 'service_name'
			},
			'on-off': 'services',
			'column_id': 'service_id',
			'filters': {
				'radio': {
					// записывается в формате: field_name: title
					'service_status': 'main/status'
				},
				'select': {
					'plan_id': 'plan/plan'
				},
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				}
			},
			'columns': {
				'service_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 70px',
					'class-row': 'text-right'
				},
				'service_name_full': {
					'title': 'service/cert_crt',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.service_id ? '/certificate/view/' + row.service_id : ''
				},
				'service_status': {
					'sort': true,
					'style-col': 'width: 120px',
					'component-row': 'status_info',
					'function-row': (row, raw) => Helper.cellStatus('service_status', row, raw),
					'function-cell-class': (row) => 'w5-status-color-' + row['service_status']
				},
				'service_end': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 96px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly',
					'function-cell-class': (row) => 'service-end-date w5-status-color-' + String(row['service_end_color']).toLowerCase()
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.account_id ? '/account/view/' + row.account_id : ''
				}
			},
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name_full',
						'timer': 5
					}
				},
				'note': {
					'title': 'notes/notes',
					'action': 'func:GoTo:notes:service:note_object'
				},
				'createNote': {
					'title': 'notes/create_note',
					'action': 'func:createNoteFromMenu'
				},
				'request': {
					'title': 'request/title',
					'action': 'func:GoTo:request::service_id'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				},
				'prolong': {
					'title': 'service/prolong',
					'action': 'func:prolongService'
				},
				'clientTicket': {
					'title': 'ticket/write',
					'action': 'func:clientTicket'
				}
			}
		}
	},

	//=========================================================================
	// DNS
	//=========================================================================
	'dns': {
		'model': 'ServiceSearch',
		'list': {
			'buttons': {
				'bulkDel': 'service_name',
				'create': 'dns/create_domain',
				'off': 'service_name',
				'on': 'service_name',
				'serviceMove': 'service_name'
			},
			'on-off': 'services',
			'column_id': 'service_id',
			'filters': {
				'radio': {
					// записывается в формате: field_name: title
					'service_status': 'main/status'
				},
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				}
			},
			'columns': {
				'service_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 70px',
					'class-row': 'text-right'
				},
				'service_name_full': {
					'sort': true,
					'title': 'service/service',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.service_id ? '/dns/view/' + row.service_id : '',
					'component-param-statusService': (row) => row['service_status'],
					'component-param-statusServiceText': (row) => row['service_status_text'],
					'domain-online-status': (row) => row && row['service_data'] && row['service_data']['real'] === true
				},
				'service_status': {
					'sort': true,
					'style-col': 'width: 120px',
					'component-row': 'status_info',
					'function-row': (row, raw) => Helper.cellStatus('service_status', row, raw),
					'function-cell-class': (row) => 'w5-status-color-' + row['service_status']
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.account_id ? '/account/view/' + row.account_id : ''
				}
			},
			'opers': {
				'update': {
					'action': 'url:/dns/view'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name_full',
						'timer': 5
					}
				},
				'note': {
					'title': 'notes/notes',
					'action': 'func:GoTo:notes:service:note_object'
				},
				'createNote': {
					'title': 'notes/create_note',
					'action': 'func:createNoteFromMenu'
				},
				'request': {
					'title': 'request/title',
					'action': 'func:GoTo:request::service_id'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				},
				'prolong': {
					'title': 'service/prolong',
					'action': 'func:prolongService'
				},
				'clientTicket': {
					'title': 'ticket/write',
					'action': 'func:clientTicket'
				}
			}
		},
		'hint-link': {
			'create': {
				position: 'bottom',
				title: 'field/hint_ns_servers',
				link: process.env.QA_SERVER + '/q/kakie-ns-servery-ispolzovat'
			}
		}
	},

	//=========================================================================
	// ACCOUNT
	//=========================================================================
	'account': {
		'list': {
			'can_select_rows': false,
			'column_id': 'account_id',
			'filters': {
				'period': {
					'begin_field': 'account_date_start',
					'end_field': 'account_date_end'
				}
			},
			'columns': {
				'account_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.account_id ? '/account/view/' + row.account_id : ''
				},
				'account_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				},
				'account_partner_name': {
					'sort': true,
					'style-col': 'width: 80px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.account_partner_id ? '/account/view/' + row.account_partner_id : ''
				},
				'real_balance': {
					'sort': true,
					'style-col': 'width: 100px',
					'class-col': 'text-right',
					'class-row': 'text-right font-weight-500',
					'component-row': 'formated_number',
					'component-param-cell-class': row => {
						if (!row || !('real_balance' in row) || row['real_balance'] === null || row['real_balance'] === undefined) return false
						if (row['real_balance'].charAt(0) !== '-') return false
						else return 'color-red'
					},
					'component-param-cell': (row, digits) => {
						if (!row || !('real_balance' in row) || row['real_balance'] === null || row['real_balance'] === undefined)
							return ''
						return Helper.Num2Money(row['real_balance'], digits)
					}
				}
			},
			'opers': {
				'update': {
					'action': 'url:/account/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'account_name'
					}
				},
				'operation': {
					'title': 'operation/operations',
					'action': 'func:GoTo:operation::account_id'
				},
				'note': {
					'title': 'notes/notes',
					'action': 'func:GoTo:notes::account_id'
				},
				'createNote': {
					'title': 'notes/create_note',
					'action': 'func:createNoteFromMenu'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:account:log_sub'
				},
				'user': {
					'title': 'account/users',
					'action': 'func:GoTo:user::account_id'
				},
				'request': {
					'title': 'request/title',
					'action': 'func:GoTo:request::account_id'
				},
				'bonusActivate': {
					'title': 'bonus/convert',
					'action': 'func:bonusActivateFromMenu'
				},
				'clientTicket': {
					'title': 'ticket/write',
					'action': 'func:clientTicket'
				},
				'accountReport': {
					'title': 'main/text_report',
					'action': 'func:accountReport'
				}
			}
		}
	},

	//=========================================================================
	// USER
	//=========================================================================
	'user': {
		'list': {
			'buttons': {
				'create': 'user/create_title',
				'off': 'user_email',
				'on': 'user_email'
			},
			'on-off': 'users',
			'column_id': 'user_id',
			'filters': {
				'period': {
					'begin_field': 'user_date_start',
					'end_field': 'user_date_end'
				},
				'radio': {
					'user_status': 'main/status'
				}
			},
			'columns': {
				'user_email': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.user_id ? '/user/view/' + row.user_id : '',
					'user-online-status': 'user_online'
				},
				'user_status': {
					'sort': true,
					'style-col': 'width: 150px',
					'function-row': (row, raw) => Helper.cellUserStatusValue(row, raw, ['lower', 'ftc']),
					'function-cell-class': (row) => 'w5-breaked-text w5-status-color-' + row['user_status']
				},
				'user_full_access': {
					'sort': true,
					'style-col': 'width: 110px',
					'function-row': (row, raw) => row['user_full_access'] === true ? Helper.localeFtc('main/yes') : Helper.localeFtc('main/no'),
					'function-cell-class': (row) => 'w5-user-accesses'
				},
				'user_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.account_id ? '/account/view/' + row.account_id : ''
				}
			},
			'opers': {
				'update': {
					'action': 'url:/user/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'user_email'
					}
				},
				'operation': {
					'title': 'operation/operations',
					'action': 'func:GoTo:operation::account_id'
				},
				'note': {
					'title': 'notes/notes',
					'action': 'func:GoTo:notes:user:note_object'
				},
				'createNote': {
					'title': 'notes/create_note',
					'action': 'func:createNoteFromMenu'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:user:log_sub'
				},
				'logOver': {
					'title': 'user/actions',
					'action': 'func:GoTo:logs::user_id'
				},
				'clientTicket': {
					'title': 'ticket/write',
					'action': 'func:clientTicket'
				}
			}
		}
	},

	//=========================================================================
	// NOTES
	//=========================================================================
	'notes': {
		'list': {
			'can_select_rows': false,
			'column_id': 'note_id',
			'filters': {
				'period': {
					'begin_field': 'note_date_start',
					'end_field': 'note_date_end'
				},
				'radio': {
					'note_type': 'notes/type',
					'note_object': 'main/object'
				}
			},
			'columns': {
				'note_date': {
					'sort': true,
					'style-col': 'width: 140px',
					'title': 'notes/info',
					'component-row': 'note_info',
					'component-param-date': (row) => Helper.FormatDateTime(row['note_date'], 'd.m.y H:M'),
					'component-param-url1': (row) => '/account/view/' + row['account_id'],
					'component-param-text1': (row) => row['account_name'],
					'component-param-url2': (row) => '/' + row['user_type'] + '/view/' + row['user_id'],
					'component-param-text2': (row) => row['user_email'],
					'user-online-status': 'user_online'
				},
				'note_object': {
					'sort': true,
					'style-col': 'width: 220px',
					'title': 'main/object',
					'component-row': 'linkComponent',
					'component-param-url': (row) => {
						if (row['object_link'] === null || row['object_link'] === undefined) return ''
						if (row['object_id'] === null || row['object_id'] === undefined) return ''

						return String(row['object_link']).trim().replace('%ID%', String(row['object_id']).trim())
					},
					'component-param-text': (row) => {
						let _value1 = row['object_type_text'] !== null && row['object_type_text'] !== undefined ? String(row['object_type_text']).trim() : ''
						let _value2 = row['object_name'] !== null && row['object_name'] !== undefined ? String(row['object_name']).trim() : ''

						let _value = _value1
						if (_value2 !== '')
						{
							if (_value !== '') _value += '<br>' + _value2
							else _value += _value2
						}

						return _value
					}
				},
				'note_text': {
					'title': 'notes/text',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.note_id ? '/notes/view/' + row.note_id : '',
					'component-param-icon': (row) => row && row.note_file ? 'file-download' : null,
					'component-param-text': (row) => {
						if (!row) return

						let _text = (row.note_text && row.note_text.length > 0) ? (row.note_text.length > 120) ? row.note_text.substr(0, 120) + '...' : row.note_text : ''
						if (row.note_file && (!_text || _text === ''))
						{
							_text = ''
							if (row && 'note_type' in row) _text += row['note_type']
							if (row && 'note_size' in row) _text += ' (' + row['note_size'] + ')'
						}

						return _text
					},
					'function-cell-class': () => 'white-space-normal'
				}
			},
			'opers': {
				'create': {
					'action': 'url:/notes/create'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'notes/delete_request_1',
						'note': 'object_id'
					}
				}
			}
		}
	},

	//=========================================================================
	// OPERATION
	//=========================================================================
	'operation': {
		'list': {
			'can_select_rows': false,
			'buttons': {
				'create': 'operation/create_title',
				'exportCsv': 'main/export CSV'
			},
			'column_id': 'operation_id',
			'filters': {
				'period': {
					'begin_field': 'operation_date_start',
					'end_field': 'operation_date_end'
				},
				// их может быть несколько, поэтому в виде объекта
				'radio': {
					// записывается в формате: field_name: title
					'operation_purse': 'operation/purse',
					'operation_type': 'main/type',
					'operation_status': 'main/status'
				},
				'select': {
					'payment_id': 'payment/payment',
					'payment_type': 'main/type payment/payment'
				}
			},
			'columns': {
				'operation_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 80px',
					'class-row': 'text-right',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.operation_id ? '/operation/view/' + row.operation_id : ''
				},
				'operation_updated': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 100px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateHM'
				},
				'operation_summa': {
					'sort': true,
					'style-col': 'width: 90px',
					'class-col': 'text-right',
					'class-row': 'text-right font-weight-500',
					'component-row': 'formated_number',
					'component-param-cell': (row, digits) => {
						if (!row || !('operation_summa' in row) || row['operation_summa'] === null || row['operation_summa'] === undefined)
							return ''
						if (!row || !('operation_type' in row) || row['operation_type'] === null || row['operation_type'] === undefined)
							return row['operation_summa']
						return row['operation_type'] === 1 ? '+' + Helper.Num2Money(row['operation_summa'], digits) : '-' + Helper.Num2Money(row['operation_summa'], digits)
					}
				},
				'operation_purse': {
					'sort': true,
					'style-col': 'width: 80px',
					'function-row': (row, raw) => Helper.cellValueFromList('operation_purse', row, raw, ['ftc']),
					'function-cell-class': (row) => 'w5-operation-purse'
				},
				'payment_id': {
					'sort': true,
					'title': 'payment/details',
					'component-row': 'linkComponent',
					'component-param-text': (row, raw) => Helper.cellOperationPayment_Text(row, raw),
					'component-param-url': (row, raw) => Helper.cellOperationPayment_Url(row, raw)
				},
				'operation_status': {
					'sort': true,
					'style-col': 'width: 90px',
					'function-row': (row, raw) => Helper.cellValueFromList('operation_status', row, raw, ['lower', 'ftc']),
					'function-cell-class': (row) => 'w5-breaked-text w5-status-color-' + row['operation_status']
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.account_id ? '/account/view/' + row.account_id : ''
				}
			},
			'opers': {
				'update': {
					'action': 'url:/operation/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'operation_id'
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:operation:log_sub'
				},
				'paymentLink': {
					'title': 'operation/get_payment_link',
					'action': 'func:showPaymentLink'
				}
			}
		}
	},

	//=========================================================================
	// PAYMENTSAVED
	//=========================================================================
	'paymentsaved': {
		'model': 'PaymentSavedSearch',
		'list': {
			'column_id': 'saved_id',
			'columns': {
				'saved_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 60px',
					'class-row': 'text-right'
				},
				'saved_image': {
					'title': 'main/type',
					'style-col': 'width: 60px',
					'class-row': 'text-center vertical-align-middle xs-img',
					'class-col': 'text-center',
					'component-row': 'image',
					'component-param-url': (row) => Helper.makeUrlForApi(row.saved_image)
				},
				'saved_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.saved_id ? '/paymentsaved/view/' + row.saved_id : ''
				},
				'saved_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.account_id ? '/account/view/' + row.account_id : ''
				}
			},
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'saved_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:paymentsaved:log_sub'
				}
			}
		}
	},

	//=========================================================================
	// PAYMENTAUTO
	//=========================================================================
	'paymentauto': {
		'model': 'PaymentAutoSearch',
		'list': {
			'buttons': {
				'create': 'paymentauto/create_title',
				'off': '-saved_name',
				'on': '-saved_name'
			},
			'on-off': 'payments',
			'column_id': 'auto_id',
			'filters': {
				'radio': {
					'auto_status': 'main/status'
				}
			},
			'columns': {
				'auto_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 60px',
					'class-row': 'text-right'
				},
				'saved_image': {
					'title': 'main/type',
					'style-col': 'width: 60px',
					'class-row': 'text-center vertical-align-middle xs-img',
					'class-col': 'text-center',
					'component-row': 'image',
					'component-param-url': (row) => Helper.makeUrlForApi(row.saved_image)
				},
				'saved_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.auto_id ? '/paymentauto/update/' + row.auto_id : ''
				},
				'auto_status': {
					'sort': true,
					'style-col': 'width: 100px',
					'component-row': 'status_info',
					'function-row': (row, raw) => Helper.cellStatus('auto_status', row, raw),
					'function-cell-class': (row) => 'w5-status-color-' + row['auto_status']
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.account_id ? '/account/view/' + row.account_id : ''
				}
			},
			'opers': {
				'update': {
					'action': 'url:/paymentauto/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'saved_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:paymentauto:log_sub'
				}
			}
		}
	},

	//=========================================================================
	// DOCUMENT
	//=========================================================================
	'document': {
		'model': 'DocumentSearch',
		'list': {
			'buttons': {
				'create': 'document/create_title'
			},
			'column_id': 'document_id',
			'filters': {
				'period': {
					'begin_field': 'doc_date_start',
					'end_field': 'doc_date_end'
				},
				'radio': {
					'document_status': 'main/status',
					'document_type': 'main/type'
				},
				'select': {
					'payer_id': 'payer/payer'
				}
			},
			'columns': {
				'document_name': {
					'sort': true,
					'component-row': 'document_html'
				},
				'document_status': {
					'sort': true,
					'style-col': 'width: 80px',
					'component-row': 'status_info',
					'function-row': (row, raw) => Helper.cellStatus('document_status', row, raw),
					'function-cell-class': (row) => 'w5-status-color-' + row['document_status']
				},
				'document_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				},
				'document_updated': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.account_id ? '/account/view/' + row.account_id : ''
				}
			},
			'opers': {
				'update': {
					'action': 'url:/document/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'document_name',
						'timer': 5
					}
				},
				'operLink': {
					'title': 'operation/operation',
					'action': 'func:goOperLink'
				},
				'mailDocument': {
					'title': 'document/mail',
					'action': 'func:goMailDocument'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:document:log_sub'
				},
				'pdfLink': {
					'title': 'main/download PDF',
					'action': 'func:goPdfLink'
				},
				'xmlLink': {
					'title': 'main/download XML',
					'action': 'func:goXmlLink'
				},
				'clientTicket': {
					'title': 'ticket/write',
					'action': 'func:clientTicket'
				}
			}
		}
	},

	//=========================================================================
	// PAYER
	//=========================================================================
	'payer': {
		'model': 'PayerSearch',
		'list': {
			'buttons': {
				'create': 'payer/create_title'
			},
			'column_id': 'payer_id',
			'filters': {
				'period': {
					'begin_field': 'payer_date_start',
					'end_field': 'payer_date_end'
				},
				'radio': {
					'payer_status': 'main/status'
				}
			},
			'columns': {
				'payer_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 60px',
					'class-row': 'text-right'
				},
				'payer_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.payer_id ? '/payer/view/' + row.payer_id : ''
				},
				'payer_updated': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 120px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				},
				'payer_status': {
					'sort': true,
					'style-col': 'width: 115px',
					'component-row': 'status_info',
					'function-row': (row, raw) => Helper.cellStatus('payer_status', row, raw),
					'function-cell-class': (row) => 'w5-status-color-' + row['payer_status']
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.account_id ? '/account/view/' + row.account_id : ''
				}
			},
			'opers': {
				'update': {
					'action': 'url:/payer/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'payer_name',
						'timer': 5
					}
				},
				'operation': {
					'title': 'operation/operations',
					'action': 'func:GoTo:operation::payer_id'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:payer:log_sub'
				}
			}
		}
	},

	//=========================================================================
	// REQUEST
	//=========================================================================
	'request': {
		'list': {
			'fast_search': false,
			'can_select_rows': false,
			'column_id': 'request_id',
			'filters': {
				'period': {
					'begin_field': 'request_date_start',
					'end_field': 'request_date_end'
				},
				// их может быть несколько, поэтому в виде объекта
				'radio': {
					'request_type': 'main/type',
					'request_status': 'main/status'
				},
				'select': {
					'service_type_id': 'servicetype/servicetype'
				}
			},
			'columns': {
				'request_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 80px',
					'class-row': 'text-right',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.request_id ? '/request/view/' + row.request_id : ''
				},
				'request_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 120px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateFormat'
				},
				'service_name_full': {
					'title': 'service/service',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.service_id ? '/service/view/' + row.service_id : ''
				},
				'request_type_text': {
					'title': 'main/type',
					'style-col': 'width: 110px',
					'function-row': (row, raw) => Helper.cellValue('request_type_text', row, raw, ['lower', 'ftc']),
					'function-cell-class': (row) => {
						let _status = row['request_type']
						let _tmp = String(row['request_type_text']).split('/').pop()
						return 'w5-breaked-text w5-status-color-' + (_tmp !== null && _tmp !== undefined && _tmp !== '' ? _tmp : _status)
					}
				},
				'request_status': {
					'style-col': 'width: 115px',
					'component-row': 'status_info',
					'function-row': (row, raw) => Helper.cellStatus('request_status', row, raw),
					'function-cell-class': (row) => 'w5-breaked-text w5-status-color-' + row['request_status']
				},
				'account_name': {
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.account_id ? '/account/view/' + row.account_id : ''
				}
			},
			'opers': {
				'update': {
					'action': 'url:/request/update'
				},
				'serviceRequest': {
					'title': 'service/filter',
					'action': 'func:GoTo:request::service_id'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:request:log_sub'
				}
			}
		}
	},

	//=========================================================================
	// PARTNER
	//=========================================================================
	'partner': {
		'list': {
			'can_select_rows': false,
			'buttons': {
				'create': 'partner/create_title'
			},
			'fast_search': true,
			'column_id': 'p2a_id',
			'columns': {
				'program_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.program_id ? '/partnerprogram/view/' + row.program_id : ''
				},
				'p2a_code': {
					'sort': true,
					'title': 'partner/code',
					'component-row': 'partner_code'
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.account_id ? '/account/view/' + row.account_id : ''
				}
			},
			'opers': {
				'update': {
					'action': 'url:/partner/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'program_name',
						'timer': 5
					}
				},
				'partnerAction': {
					'title': 'partneractions/title',
					'action': 'func:GoTo:partneractions::p2a_id'
				}
			}
		}
	},

	//=========================================================================
	// PARTNERPROGRAM
	//=========================================================================
	'partnerprogram': {
		'model': 'PartnerProgramSearch',
		'list': {
			'can_select_rows': false,
			'buttons': {
				'create': 'partnerprogram/create_title'
			},
			'fast_search': true,
			'column_id': 'program_id',
			'columns': {
				'program_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.program_id ? '/partnerprogram/view/' + row.program_id : ''
				},
				'program_status': {
					'sort': true,
					'function-row': (row, raw) => Helper.cellValueFromList('program_status', row, raw, ['ftc']),
					'function-cell-class': (row) => 'w5-breaked-text w5-status-color-' + row['program_status']
				}
			},
			'opers': {
				'update': {
					'action': 'url:/partnerprogram/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'program_name',
						'timer': 5
					}
				},
				'partner': {
					'title': 'partner/title',
					'action': 'func:GoTo:partner::program_id'
				},
				'partnerAction': {
					'title': 'partneractions/title',
					'action': 'func:GoTo:partneractions'
				}
			}
		}
	},

	//=========================================================================
	// PARTNERACTIONS
	//=========================================================================
	'partneractions': {
		'model': 'PartnerActionsSearch',
		'list': {
			'can_select_rows': false,
			'column_id': 'click_id',
			'filters': {
				'period': {
					'begin_field': 'click_date_start',
					'end_field': 'click_date_end'
				}
			},
			'columns': {
				'owner_account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.owner_account_id ? '/account/view/' + row.owner_account_id : ''
				},
				'created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 120px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateFormat'
				},
				'program_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.program_id ? '/partnerprogram/view/' + row.program_id : ''
				},
				'http_referer': {
					'sort': true,
					'component-row': 'http_referer'
				},
				'ip': {
					'sort': true,
					'style-col': 'width: 120px'
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 120px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.account_id ? '/account/view/' + row.account_id : ''
				},
				'real_balance': {
					'sort': true,
					'style-col': 'width: 100px',
					'class-col': 'text-right',
					'class-row': 'text-right font-weight-500',
					'component-row': 'formated_number',
					'component-param-cell-class': row => {
						if (!row || !('real_balance' in row) || row['real_balance'] === null || row['real_balance'] === undefined) return false
						if (row['real_balance'].charAt(0) !== '-') return false
						else return 'color-red'
					},
					'component-param-cell': (row, digits) => {
						if (!row || !('real_balance' in row) || row['real_balance'] === null || row['real_balance'] === undefined)
							return ''
						return Helper.Num2Money(row['real_balance'], digits)
					}
				}
			}
		}
	},

	//=========================================================================
	// BONUS
	//=========================================================================
	'bonus': {
		'list': {
			'buttons': {
				'create': 'bonus/create_title',
				'off': '-bonus_name', // если с минусом - значит заметка не нужна
				'on': '-bonus_name'
			},
			'on-off': 'bonuses',
			'column_id': 'bonus_id',
			'filters': {
				'period': {
					'begin_field': 'bonus_date_start',
					'end_field': 'bonus_date_end'
				},
				// их может быть несколько, поэтому в виде объекта
				'radio': {
					// записывается в формате: field_name: title
					'bonus_status': 'main/status',
					'bonus_type': 'main/type'
				}
			},
			'columns': {
				'bonus_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.bonus_id ? '/bonus/view/' + row.bonus_id : ''
				},
				'bonus_start': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 97px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly',
					'function-cell-style': (row) => row['bonus_start_color'] ? 'color: ' + row['bonus_start_color'] : null
				},
				'bonus_stop': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 97px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly',
					'function-cell-style': (row) => row['bonus_stop_color'] ? 'color: ' + row['bonus_stop_color'] : null
				},
				'bonus_end': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 97px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly',
					'function-cell-style': (row) => row['bonus_end_color'] ? 'color: ' + row['bonus_end_color'] : null
				},
				'bonus_status': {
					'sort': true,
					'style-col': 'width: 120px',
					'function-row': (row, raw) => Helper.cellValueFromList('bonus_status', row, raw, ['lower', 'ftc']),
					'function-cell-class': (row) => 'w5-breaked-text w5-status-color-' + row['bonus_status']
				},
				'bonus_type': {
					'sort': true,
					'style-col': 'width: 140px',
					'function-row': (row, raw) => Helper.cellValueFromList('bonus_type', row, raw, ['ftc'])
				}
			},
			'opers': {
				'update': {
					'action': 'url:/bonus/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'bonus_name'
					}
				},
				'account': {
					'title': 'account/title',
					'action': 'func:GoTo:account::bonus_id'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:bonus:log_sub'
				},
				'bonusActivate': {
					'title': 'bonus/convert',
					'action': 'func:bonusActivateFromMenu'
				}
			}
		}
	},

	//=========================================================================
	// TICKET
	//=========================================================================
	'ticket': {
		'list': {
			'buttons': {
				'create': 'ticket/create_title',
				'blockTicket': 'ticket/blacklist',
				'closeTicket': 'main/closing',
				'replaceTicket': 'ticketrule/action_move'
			},
			'column_id': 'ticket_id',
			'filters': {
				'period': {
					'begin_field': 'ticket_date_start',
					'end_field': 'ticket_date_end'
				},
				'radio': {
					'ticket_status': 'main/status'
				},
				'select': {
					'has_mark': 'ticketmessage/mark'
				},
				'ticketLabel': {
				},
				'myTickets': {
				},
				'bool': {
					'title_false': 'ticket/show_closed',
					'title_true': 'ticket/hide_closed',
					'field': 'show_closed'
				}
			},
			'columns': {
				'ticket_label': {
					'style-col': 'width: 30px',
					'component-row': 'ticket_label',
					'function-cell-class': (row) => 'cursor-pointer ticket-label-color-' + String(row['ticket_label']).toLowerCase(),
					'function-cell-style': (row) => 'background-color: ' + String(row['ticket_label']).toLowerCase()
				},
				'ticket_subject': {
					'sort': true,
					'component-row': 'ticket_subject'
				},
				'ticket_status': {
					'sort': true,
					'style-col': 'width: 120px',
					'function-row': (row, raw) => Helper.cellValueFromList('ticket_status', row, raw, ['lower', 'ftc']),
					'function-cell-class': (row) => 'w5-breaked-text w5-status-color-' + String(row['ticket_status_color']).toLowerCase() + ' ticket-status-name-' + String(row['ticket_status']).toLowerCase()
				},
				'ticket_updated': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 110px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateHM'
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.account_id ? '/account/view/' + row.account_id : ''
				}
			},
			'opers': {
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:ticket:log_sub'
				},
				'ticketMerge': {
					'title': 'ticket/merge',
					'action': 'func:ticketMergeFromMenu'
				}
			}
		}
	},

	//=========================================================================
	// LOGS
	//=========================================================================
	'logs': {
		'list': {
			'can_select_rows': false,
			'column_id': 'log_id',
			'filters': {
				'period': {
					'begin_field': 'log_date_start',
					'end_field': 'log_date_end'
				},
				'logs': {
					'field': 'log_action'
				}
			},
			'columns': {
				'log_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 80px',
					'class-row': 'text-right',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.log_id ? '/logs/view/' + row.log_id : ''
				},
				'log_date': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 120px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateFormat'
				},
				'log_action': {
					'sort': true,
					'style-col': 'width: 150px',
					'function-row': (row, listData, ftc) => row && row.log_action_text
						? ftc && typeof ftc === 'function' ? ftc(row.log_action_text) : row.log_action_text
						: '',
					'function-cell-class': (row) => 'w5-breaked-text'
				},
				'log_ip': {
					'sort': true,
					'style-col': 'width: 110px'
				},
				'log_sub': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.object_link ? row.object_link.replace('%ID%', row.object_id) : '',
					'component-param-text': (row) => row && row.object_name ? row.object_name : ''
				},
				'user_email': {
					'sort': true,
					'style-col': 'width: 150px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.user_type && row.user_id ? '/' + row.user_type + '/view/' + row.user_id : '',
					'user-online-status': 'user_online'
				}
			}
		}
	},

	//=========================================================================
	// CHART
	//=========================================================================
	'chart': {
		'list': {
			'can_select_rows': false,
			'fast_search': false,
			'column_id': 'chart_id',
			'columns': {
				'chart_name': {
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.chart_id ? '/chart/view/' + row.chart_id : ''
				}
			}
		}
	},

	//=========================================================================
	// TEMPLATE
	//=========================================================================
	'template': {
		'list': {
			'buttons': {
				'create': 'template/create_title',
				'off': '-template_name',
				'on': '-template_name'
			},
			'on-off': 'templates',
			'column_id': 'template_id',
			'filters': {
				'radio': {
					'template_status': 'main/status'
				},
				'select': {
					'server_group_id': 'server/groups'
				}
			},
			'columns': {
				'template_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 70px',
					'class-row': 'text-right'
				},
				'template_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.template_id ? '/template/view/' + row.template_id : ''
				},
				'groups': {
					'sort': true,
					'component-row': 'server_groups'
				},
				'template_status': {
					'sort': true,
					'style-col': 'width: 100px',
					'function-row': (row, raw) => Helper.cellValueFromList('template_status', row, raw, ['lower', 'ftc']),
					'function-cell-class': (row) => 'w5-breaked-text w5-status-color-' + row['template_status']
				},
				'template_sort': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 65px',
					'class-row': 'text-right'
				}
			},
			'opers': {
				'update': {
					'action': 'url:/template/update'
				},
				'clone': {
					'action': 'url:/template/clone'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'template_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:template:log_sub'
				}
			}
		}
	},

	//=========================================================================
	// IPPOOL
	//=========================================================================
	'ippool': {
		'model': 'IpPoolSearch',
		'list': {
			'buttons': {
				'create': 'ippool/create_title',
				'ip_off': 'ip_address',
				'ip_on': 'ip_address'
			},
			'on-off': 'ips',
			'column_id': 'ip_id',
			'filters': {
				'radio': {
					'ip_status': 'main/status',
					'ip_type': 'main/type',
					'view_type': 'ippool/view_type',
					'ip_owner': 'rackdevice/owner'
				},
				'select': {
					'view_net': 'ippool/view_net',
					'datacenter_id': 'datacenter/datacenter',
					'ip_server_type': 'server/type',
					'ip_bridge': 'Bridge'
				}
			},
			'columns': {
				'ip_address': {
					'sort': true,
					'style-col': 'width: 130px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.ip_id ? '/ippool/view/' + row.ip_id : ''
				},
				'ip_host': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.ip_id ? '/ipptrpool/list?id=' + row.ip_id : ''
				},
				'ip_server_type': {
					'sort': true,
					'style-col': 'width: 100px',
					'function-row': (row, raw) => Helper.cellValueFromList('ip_server_type', row, raw, ['ftc'])
				},
				'datacenter_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.datacenter_id ? '/datacenter/view/' + row.datacenter_id : '',
					'component-param-flagicon': (row) => 'flag-icon-' + String(row['datacenter_country'])
				},
				'ip_status': {
					'sort': true,
					'style-col': 'width: 100px',
					'function-row': (row, raw) => Helper.cellValueFromList('ip_status', row, raw, ['lower', 'ftc']),
					'function-cell-class': (row) => 'w5-breaked-text w5-status-color-' + row['ip_status']
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.account_id ? '/account/view/' + row.account_id : ''
				}
			},
			'opers': {
				'update': {
					'action': 'url:/ippool/update'
				},
				'ipptrpool': {
					'title': 'ipptrpool/title',
					'action': 'url:/ipptrpool/list'
				},
				'ipHistory': {
					'title': 'service/history IP',
					'action': 'url:/iphistory/list'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:ippool:log_sub'
				}
			}
		}
	},

	//=========================================================================
	// IPPTRPOOL
	//=========================================================================
	'ipptrpool': {
		'model': 'IpPtrPoolSearch',
		'list': {
			'buttons': {
				'create': 'ipptrpool/create_title'
			},
			'column_id': 'ptr_id',
			'columns': {
				'ptr_address': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.ptr_id ? '/ipptrpool/view/' + row.ptr_id : ''
				},
				'ptr_host': {
					'sort': true
				},
				'ptr_timestamp': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 110px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateFormat'
				}
			},
			'oneOper': {
				'columnWidth': '60px',
				'update': {
					'action': 'url:/ipptrpool/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'ptr_address'
					}
				}
			}
		}
	},

	//=========================================================================
	// IPHISTORY
	//=========================================================================
	'iphistory': {
		'model': 'IpHistorySearch',
		'list': {
			'column_id': 'service_id',
			'filters': {
				'radio': {
					'service_status': 'main/status'
				},
				'period': {
					'begin_field': 'history_date_start',
					'end_field': 'history_date_end'
				}
			},
			'columns': {
				'service_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.service_id ? '/service/view/' + row.service_id : ''
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.account_id ? '/account/view/' + row.account_id : ''
				},
				'service_status': {
					'sort': true,
					'style-col': 'width: 100px',
					'function-row': (row, raw) => Helper.cellValueFromList('service_status', row, raw, ['lower', 'ftc']),
					'function-cell-class': (row) => 'w5-breaked-text w5-status-color-' + row['service_status']
				},
				'history_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 120px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateFormat'
				},
				'history_deleted': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 120px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateFormat'
				}
			}
		}
	},

	//=========================================================================
	// TEXT
	//=========================================================================
	'text': {
		'list': {
			'can_select_rows': false,
			'buttons': {
				'create': 'text/create_title'
			},
			'column_id': 'id',
			'filters': {
				'select': {
					'fast_filter': 'text/fast_filter'
				}
			},
			'columns': {
				'category': {
					'sort': true
				},
				'message': {
					'sort': true
				},
				'translation': {
					'sort': true
				}
			},
			'opers': {
				'update': {
					'action': 'url:/text/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'message'
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:text:log_sub'
				}
			}
		}
	},

	//=========================================================================
	// ADMIN
	//=========================================================================
	'admin': {
		'list': {
			'buttons': {
				'create': 'admin/create_title',
				'off': 'user_email',
				'on': 'user_email'
			},
			'on-off': 'users',
			'column_id': 'user_id',
			'columns': {
				'user_email': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.user_id ? '/admin/view/' + row.user_id : '',
					'user-online-status': 'user_online'
				},
				'user_name': {
					'sort': true
				},
				'user_role': {
					'sort': true,
					'component-row': 'admin_roles'
				},
				'user_status': {
					'sort': true,
					'style-col': 'width: 100px',
					'function-row': (row, raw) => Helper.cellValueFromList('user_status', row, raw, ['lower', 'ftc']),
					'function-cell-class': (row) => 'w5-breaked-text w5-status-color-' + row['user_status']
				}
			},
			'opers': {
				'update': {
					'action': 'url:/admin/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'user_email',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:admin:log_sub'
				},
				'logOver': {
					'title': 'admin/actions',
					'action': 'func:GoTo:logs::user_id'
				},
				'note': {
					'title': 'admin/notes',
					'action': 'func:GoTo:notes:admin:note_object'
				},
				'createNote': {
					'title': 'notes/create_note',
					'action': 'func:createNoteFromMenu'
				}
			}
		}
	},

	//=========================================================================
	// ROLE
	//=========================================================================
	'role': {
		'list': {
			'fast_search': false,
			'can_select_rows': false,
			'buttons': {
				'create': 'role/create_title'
			},
			'column_id': 'role_name',
			'columns': {
				'role_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.role_name ? '/role/view/' + row.role_name : ''
				},
				'role_type': {
					'sort': true,
					'function-cell-class': (row) => 'role_actions' in row && row['role_actions'] === false ? 'color-light-gray' : false
				}
			},
			'opers': {
				'update': {
					'action': 'url:/role/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'role_name'
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:role:log_sub'
				}
			}
		}
	},

	//=========================================================================
	// PAYMENT
	//=========================================================================
	'payment': {
		'list': {
			'buttons': {
				'create': 'payment/create_title',
				'off': '-payment_name',
				'on': '-payment_name'
			},
			'on-off': 'payments',
			'column_id': 'payment_id',
			'columns': {
				'payment_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.payment_id ? '/payment/view/' + row.payment_id : ''
				},
				'payment_type': {
					'sort': true,
					'function-row': (row, raw) => Helper.cellValueFromList('payment_type', row, raw, ['ftc']),
					'function-cell-class': (row) => 'w5-breaked-text'
				},
				'payment_status': {
					'sort': true,
					'style-col': 'width: 100px',
					'function-row': (row, raw) => Helper.cellValueFromList('payment_status', row, raw, ['lower', 'ftc']),
					'function-cell-class': (row) => 'w5-breaked-text w5-status-color-' + row['payment_status']
				},
				'payment_comission': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 80px',
					'class-row': 'text-right',
					'function-row': (row) => row['payment_comission'] + '%'
				},
				'payment_sort': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 65px',
					'class-row': 'text-right'
				}
			},
			'opers': {
				'update': {
					'action': 'url:/payment/update'
				},
				'clone': {
					'action': 'url:/payment/clone'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'payment_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:payment:log_sub'
				}
			}
		}
	},

	//=========================================================================
	// DATACENTER
	//=========================================================================
	'datacenter': {
		'list': {
			'can_select_rows': false,
			'buttons': {
				'create': 'datacenter/create_title'
			},
			'column_id': 'datacenter_id',
			'columns': {
				'datacenter_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.datacenter_id ? '/datacenter/view/' + row.datacenter_id : ''
				},
				'datacenter_country': {
					'sort': true,
					'function-row': (row, raw) => Helper.cellValueFromList('datacenter_country', row, raw, ['ftc']),
					'function-flagicon': (row) => 'flag-icon-' + row['datacenter_country']
				},
				'datacenter_racks': {
					'sort': true,
					'style-col': 'width: 75px',
					'function-row': (row, raw) => row['datacenter_racks'] || '-',
					'component-row': 'CrudListFilter',
					'component-param-src-field': 'datacenter_racks',
					'component-param-crud': 'rack',
					'component-param-filter-field': 'datacenter_id'
				},
				'datacenter_servers': {
					'sort': true,
					'style-col': 'width: 75px',
					'function-row': (row, raw) => row['datacenter_servers'] || '-',
					'component-row': 'CrudListFilter',
					'component-param-src-field': 'datacenter_servers',
					'component-param-crud': 'server',
					'component-param-filter-field': 'datacenter_id'
				},
				'datacenter_sort': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 75px',
					'class-row': 'text-right'
				}
			},
			'opers': {
				'update': {
					'action': 'url:/datacenter/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'datacenter_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:datacenter:log_sub'
				},
				'server': {
					'title': 'server/title',
					'action': 'filter:server::datacenter_id'
				}
			}
		}
	},

	//=========================================================================
	// SERVERGROUP
	//=========================================================================
	'servergroup': {
		'model': 'ServerGroupSearch',
		'list': {
			'can_select_rows': false,
			'buttons': {
				'create': 'servergroup/create_title'
			},
			'column_id': 'group_id',
			'filters': {
				'radio': {
					'group_type': 'main/type'
				}
			},
			'columns': {
				'group_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.group_id ? '/servergroup/view/' + row.group_id : ''
				},
				'group_type': {
					'sort': true,
					'style-col': 'width: 110px',
					'function-row': (row, raw) => Helper.cellValueFromList('group_type', row, raw, ['ftc']),
					'function-cell-class': (row) => 'w5-breaked-text'
				},
				'group_sort': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 75px',
					'class-row': 'text-right'
				}
			},
			'opers': {
				'update': {
					'action': 'url:/servergroup/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'group_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:servergroup:log_sub'
				},
				'server': {
					'title': 'server/title',
					'action': 'filter:server::server_group_id'
				}
			}
		}
	},

	//=========================================================================
	// PLANGROUP
	//=========================================================================
	'plangroup': {
		'model': 'PlanGroupSearch',
		'list': {
			'buttons': {
				'create': 'plangroup/create_title',
				'off': '-group_name',
				'on': '-group_name'
			},
			'on-off': 'plangroups',
			'column_id': 'group_id',
			'filters': {
				'radio': {
					'group_type': 'main/type'
				}
			},
			'columns': {
				'group_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.group_id ? '/plangroup/view/' + row.group_id : ''
				},
				'group_type': {
					'sort': true,
					'style-col': 'width: 110px',
					'function-row': (row, raw) => Helper.cellValueFromList('group_type', row, raw, ['ftc']),
					'function-cell-class': (row) => 'w5-breaked-text'
				},
				'group_status': {
					'sort': true,
					'style-col': 'width: 110px',
					'class-col': 'aw5-vds-column-status',
					'component-row': 'status_info',
					'function-row': (row, raw) => Helper.cellStatus('group_status', row, raw),
					'function-cell-class': (row) => 'w5-status-color-' + row['group_status']
				},
				'group_sort': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 75px',
					'class-row': 'text-right'
				}
			},
			'opers': {
				'update': {
					'action': 'url:/plangroup/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'group_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:plangroup:log_sub'
				},
				'plan': {
					'title': 'plan/title',
					'action': 'filter:plan::plan_group_id'
				}
			}
		}
	},

	//=========================================================================
	// SERVER
	//=========================================================================
	'server': {
		'list': {
			'buttons': {
				'create': 'server/create_title',
				'r_off': 'server_name',
				'r_on': 'server_name'
			},
			'on-off': 'servers',
			'column_id': 'server_id',
			'filters': {
				'radio': {
					'server_type': 'server/type',
					'server_status': 'main/status',
					'server_register': 'server/register'
				},
				'select': {
					'server_group_id': 'server/groups',
					'datacenter_id': 'datacenter/datacenter',
					'server_view_type': 'main/type'
				}
			},
			'columns': {
				'server_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.server_id ? '/server/view/' + row.server_id : ''
				},
				'server_type': {
					'sort': true,
					'style-col': 'width: 110px',
					'function-row': (row, raw) => Helper.cellValueFromList('server_type', row, raw, ['ftc']),
					'function-cell-class': (row) => 'w5-breaked-text'
				},
				'datacenter_name': {
					'sort': true,
					'style-col': 'width: 150px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.datacenter_id ? '/datacenter/view/' + row.datacenter_id : '',
					'component-param-flagicon': (row) => 'flag-icon-' + String(row['datacenter_country'])
				},
				'server_view_type': {
					'sort': true,
					'style-col': 'width: 100px',
					'function-row': (row, raw) => Helper.cellValueFromList('server_view_type', row, raw, ['lower', 'ftc']),
					'function-cell-class': (row) => 'w5-breaked-text color-type-' + row['server_view_type']
				},
				'server_register': {
					'sort': true,
					'style-col': 'width: 100px',
					'function-row': (row, raw) => Helper.cellValueFromList('server_register', row, raw, ['lower', 'ftc']),
					'function-cell-class': (row) => 'w5-breaked-text w5-status-color-' + row['server_register']
				},
				'server_status': {
					'sort': true,
					'style-col': 'width: 100px',
					'function-row': (row, raw) => Helper.cellValueFromList('server_status', row, raw, ['lower', 'ftc']),
					'function-cell-class': (row) => 'w5-breaked-text w5-status-color-' + row['server_status']
				},
				'server_ip': {
					'sort': true,
					'style-col': 'width: 110px'
				}
			},
			'opers': {
				'update': {
					'action': 'url:/server/update'
				},
				'clone': {
					'action': 'url:/server/clone'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'server_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:server:log_sub'
				}
			}
		}
	},

	//=========================================================================
	// SERVICETYPE
	//=========================================================================
	'servicetype': {
		'model': 'ServiceTypeSearch',
		'list': {
			'buttons': {
				'off': '-service_type_name',
				'on': '-service_type_name'
			},
			'on-off': 'servicetypes',
			'column_id': 'service_type_id',
			'filters': {
				'radio': {
					'service_type_status': 'main/status',
					'parent_type_id': 'servicetype/parent'
				}
			},
			'columns': {
				'service_type_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.service_type_id ? '/servicetype/view/' + row.service_type_id : ''
				},
				'parent_type_name': {
					'title': 'servicetype/parent',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.parent_type_id ? '/servicetype/view/' + row.parent_type_id : ''
				},
				'service_type_cost': {
					'sort': true,
					'component-row': 'service_type_cost',
					'function-row': (row, raw) => Helper.cellValueServiceTypeCost(row, raw)
				},
				'service_type_status': {
					'sort': true,
					'style-col': 'width: 100px',
					'function-row': (row, raw) => Helper.cellValueFromList('service_type_status', row, raw, ['lower', 'ftc']),
					'function-cell-class': (row) => 'w5-breaked-text w5-status-color-' + row['service_type_status']
				},
				'service_type_sort': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 65px',
					'class-row': 'text-right'
				}
			},
			'opers': {
				'create': {
					'title': 'servicetype/create_plan',
					'action': 'url:/plan/create'
				},
				'update': {
					'action': 'url:/servicetype/update'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:servicetype:log_sub'
				}
			}
		}
	},

	//=========================================================================
	// PLAN
	//=========================================================================
	'plan': {
		'list': {
			'buttons': {
				'off': '-plan_name',
				'on': '-plan_name'
			},
			'on-off': 'plans',
			'column_id': 'plan_id',
			'filters': {
				'period': {
					'begin_field': 'plan_date_start',
					'end_field': 'plan_date_end'
				},
				'radio': {
					'plan_status': 'main/status'
				},
				'select': {
					'service_type_id': 'servicetype/servicetype',
					'server_group_id': 'servergroup/servergroup',
					'plan_group_id': 'plangroup/plangroup'
				}
			},
			'columns': {
				'plan_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.plan_id ? '/plan/view/' + row.plan_id : ''
				},
				'server_group_id': {
					'sort': true,
					'component-row': 'server_groups_view'
				},
				'plan_group_id': {
					'sort': true,
					'component-row': 'plan_groups_view'
				},
				'plan_status': {
					'sort': true,
					'style-col': 'width: 100px',
					'function-row': (row, raw) => Helper.cellValueFromList('plan_status', row, raw, ['lower', 'ftc']),
					'function-cell-class': (row) => 'w5-breaked-text w5-status-color-' + row['plan_status']
				},
				'plan_cost': {
					'sort': true,
					'style-col': 'width: 120px',
					'component-row': 'plan_cost',
					'function-row': (row, raw) => Helper.cellValuePlanCost(row, raw)
				},
				'plan_sort': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 65px',
					'class-row': 'text-right'
				}
			},
			'opers': {
				'update': {
					'action': 'url:/plan/update'
				},
				'clone': {
					'action': 'url:/plan/clone'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'plan_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:plan:log_sub'
				}
			}
		}
	},

	//=========================================================================
	// PLANARCHIVE
	//=========================================================================
	'planarchive': {
		'model': 'PlanSearch',
		'list': {
			'can_select_rows': false,
			'column_id': 'plan_id',
			'filters': {
				'period': {
					'begin_field': 'plan_date_start',
					'end_field': 'plan_date_end'
				},
				'select': {
					'service_type_id': 'servicetype/servicetype',
					'server_group_id': 'servergroup/servergroup'
				}
			},
			'columns': {
				'plan_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.plan_id ? '/planarchive/view/' + row.plan_id : ''
				},
				'server_group_id': {
					'sort': true,
					'component-row': 'server_groups_view'
				},
				'plan_cost': {
					'sort': true,
					'style-col': 'width: 120px',
					'component-row': 'plan_cost',
					'function-row': (row, raw) => Helper.cellValuePlanCost(row, raw)
				},
				'plan_updated': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 120px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateFormat'
				}
			},
			'opers': {
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:plan:log_sub'
				}
			}
		}
	},

	//=========================================================================
	// DEPARTMENT
	//=========================================================================
	'department': {
		'list': {
			'can_select_rows': false,
			'buttons': {
				'create': 'department/create_title'
			},
			'column_id': 'department_id',
			'filters': {
				'select': {
					'department_type': 'department/type'
				}
			},
			'columns': {
				'department_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 60px',
					'class-row': 'text-right'
				},
				'department_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.department_id ? '/department/view/' + row.department_id : ''
				},
				'department_type': {
					'sort': true,
					'function-row': (row, raw) => Helper.cellValueFromList('department_type', row, raw, ['ftc'])
				},
				'department_manager_name': {
					'sort': true,
					'title': 'department/manager',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.department_manager ? '/admin/view/' + row.department_manager : ''
				},
				'department_sort': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 65px',
					'class-row': 'text-right'
				}
			},
			'opers': {
				'update': {
					'action': 'url:/department/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'department_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:department:log_sub'
				}
			}
		}
	},

	//=========================================================================
	// TICKETRULE
	//=========================================================================
	'ticketrule': {
		'model': 'TicketRuleSearch',
		'list': {
			'buttons': {
				'create': 'ticketrule/create_title',
				'off': '-rule_name',
				'on': '-rule_name'
			},
			'on-off': 'rules',
			'column_id': 'rule_id',
			'filters': {
				'radio': {
					'rule_status': 'main/status',
					'rule_action': 'ticketrule/action'
				}
			},
			'columns': {
				'rule_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 60px',
					'class-row': 'text-right'
				},
				'rule_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.rule_id ? '/ticketrule/view/' + row.rule_id : ''
				},
				'rule_action': {
					'sort': true,
					'style-col': 'width: 220px',
					'function-row': (row, raw) => Helper.cellValueFromList('rule_action', row, raw, ['ftc']),
					'function-cell-class': (row) => 'w5-breaked-text'
				},
				'department_name': {
					'sort': true,
					'style-col': 'width: 220px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.department_id ? '/department/view/' + row.department_id : ''
				},
				'rule_status': {
					'sort': true,
					'style-col': 'width: 100px',
					'function-row': (row, raw) => Helper.cellValueFromList('rule_status', row, raw, ['lower', 'ftc']),
					'function-cell-class': (row) => 'w5-breaked-text w5-status-color-' + row['rule_status']
				},
				'rule_sort': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 65px',
					'class-row': 'text-right'
				}
			},
			'opers': {
				'update': {
					'action': 'url:/ticketrule/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'rule_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:ticketrule:log_sub'
				}
			}
		}
	},

	//=========================================================================
	// ZONE
	//=========================================================================
	'zone': {
		'model': 'ZoneSearch',
		'list': {
			'column_id': 'zone_name',
			'columns': {
				'zone_name': {
					'sort': true
				}
			},
			'opers': {
				'update': {
					'action': 'url:/zone/update'
				}
			}
		}
	},

	//=========================================================================
	// PERSON
	//=========================================================================
	'person': {
		'model': 'PersonSearch',
		'list': {
			'buttons': {
				'create': 'person/create_title'
			},
			'column_id': 'person_id',
			'filters': {
				'select': {
					'person_type': 'main/type'
				},
				'period': {
					'begin_field': 'person_date_start',
					'end_field': 'person_date_end'
				}
			},
			'columns': {
				'person_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 60px',
					'class-row': 'text-right'
				},
				'person_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.person_id ? '/person/update/' + row.person_id : ''
				},
				'person_type': {
					'sort': true,
					'style-col': 'width: 205px',
					'function-row': (row, raw) => Helper.cellValueFromList('person_type', row, raw, ['ftc']),
					'function-cell-class': () => 'w5-breaked-text'
				},
				'person_updated': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 120px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateFormat'
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.account_id ? '/account/view/' + row.account_id : ''
				}
			},
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'person_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:person:log_sub'
				}
			}
		}
	},

	//=========================================================================
	// DOMAINS
	//=========================================================================
	'domains': {
		'model': 'ServiceSearch',
		'list': {
			'buttons': {
				'bulkDel': 'service_name',
				'create': 'service/register_domain',
				'off': 'service_name',
				'on': 'service_name',
				'serviceMove': 'service_name'
			},
			'on-off': 'services',
			'column_id': 'service_id',
			'filters': {
				'radio': {
					'service_status': 'main/status'
				},
				'select': {
					'plan_id': 'plan/plan'
				},
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				},
				'period': {
					'begin_field': 'service_date_start',
					'end_field': 'service_date_end'
				}
			},
			'columns': {
				'service_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 65px',
					'class-row': 'text-right'
				},
				'service_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.service_id ? '/domains/update/' + row.service_id : '',
					'component-param-statusService': (row) => row['service_status'],
					'component-param-statusServiceText': (row) => row['service_status_text']
				},
				'service_status': {
					'sort': true,
					'style-col': 'width: 115px',
					'component-row': 'status_info',
					'function-row': (row, raw) => Helper.cellStatus('service_status', row, raw),
					'function-cell-class': (row) => 'w5-status-color-' + row['service_status']
				},
				'service_end': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 96px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly',
					'function-cell-class': (row) => 'service-end-date w5-status-color-' + String(row['service_end_color']).toLowerCase()
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 85px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.account_id ? '/account/view/' + row.account_id : ''
				}
			},
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name_full',
						'timer': 5
					}
				},
				'note': {
					'title': 'notes/notes',
					'action': 'func:GoTo:notes:service:note_object'
				},
				'createNote': {
					'title': 'notes/create_note',
					'action': 'func:createNoteFromMenu'
				},
				'request': {
					'title': 'request/title',
					'action': 'func:GoTo:request::service_id'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				},
				'prolong': {
					'title': 'service/prolong',
					'action': 'func:prolongService'
				},
				'domainReboot': {
					'title': 'service/reboot',
					'action': 'func:RebootDomain'
				}
			}
		}
	},

	//=========================================================================
	// RACK
	//=========================================================================
	'rack': {
		'model': 'RackSearch',
		'list': {
			'buttons': {
				'create': 'main/create'
			},
			'column_id': 'rack_id',
			'filters': {
				'radio': {
					'rack_type': 'main/type'
				},
				'select': {
					'datacenter_id': 'datacenter/datacenter'
				}
			},
			'columns': {
				'rack_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.rack_id ? '/rack/view/' + row.rack_id : ''
				},
				'rack_type': {
					'sort': true,
					'style-col': 'width: 60px',
					'function-row': (row, raw) => Helper.cellValueFromList('rack_type', row, raw, ['ftc']),
					'function-cell-class': () => 'w5-breaked-text'
				},
				'datacenter_name': {
					'sort': true,
					'style-col': 'width: 200px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.datacenter_id ? '/datacenter/view/' + row.datacenter_id : '',
					'component-param-flagicon': (row) => 'flag-icon-' + String(row['datacenter_country'])
				},
				'rack_units': {
					'sort': true,
					'style-col': 'width: 80px',
					'component-row': 'CrudListFilter',
					'component-param-src-field': 'rack_units',
					'component-param-crud': 'rackdevice',
					'component-param-filter-field': 'rack_id'
				},
				'rack_power': {
					'sort': true,
					'style-col': 'width: 80px'
				},
				'rack_price': {
					'sort': true,
					'style-col': 'width: 80px'
				}
			},
			'opers': {
				'update': {
					'action': 'url:/rack/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'rack_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:rack:log_sub'
				},
				'createDevice': {
					'title': 'rackdevice/create_title',
					'action': 'func:redirectUrl:/rackdevice/create:rack_id'
				},
				'rackGraphic': {
					'title': 'rack/rack',
					'action': 'func:showRackGraphic::rack_id'
				}
			}
		}
	},

	//=========================================================================
	// RACKDEVICE
	//=========================================================================
	'rackdevice': {
		'model': 'RackDeviceSearch',
		'list': {
			'buttons': {
				'create': 'main/create'
			},
			'column_id': 'device_id',
			'filters': {
				'radio': {
					'device_type': 'main/type',
					'device_owner': 'rackdevice/owner',
					'device_server_type': 'rackdevice/server_type'
				},
				'select': {
					'datacenter_id': 'datacenter/datacenter'
				}
			},
			'columns': {
				'device_unit': {
					'sort': true,
					'style-col': 'width: 25px'
				},
				'device_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.device_id ? '/rackdevice/view/' + row.device_id : ''
				},
				'device_type': {
					'sort': true,
					'style-col': 'width: 100px',
					'function-row': (row, raw) => Helper.cellValueFromList('device_type', row, raw, ['ftc']),
					'function-cell-class': () => 'w5-breaked-text'
				},
				'rack_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.rack_id ? '/rack/view/' + row.rack_id : ''
				},
				'device_server_type': {
					'sort': true,
					'style-col': 'width: 120px',
					'function-row': (row, raw) => Helper.cellValueFromList('device_server_type', row, raw, ['ftc']),
					'function-cell-class': () => 'w5-breaked-text'
				},
				'device_owner': {
					'sort': true,
					'style-col': 'width: 80px',
					'function-row': (row, raw) => Helper.cellValueFromList('device_owner', row, raw, ['ftc']),
					'function-cell-class': () => 'w5-breaked-text'
				},
				'device_ports': {
					'sort': true,
					'style-col': 'width: 80px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.device_id ? '/rackdevice/links/' + row.device_id : '',
					'online-status-before': 'device_ports_active'
				},
				'server_name': {
					'sort': true,
					'style-col': 'width: 140px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.server_id ? '/server/view/' + row.server_id : ''
				}
			},
			'opers': {
				'update': {
					'action': 'url:/rackdevice/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'device_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:rackdevice:log_sub'
				},
				'deviceLinks': {
					'title': 'rackdevice/links_title',
					'action': 'func:redirectUrl:/rackdevice/links:device_id'
				},
				'clone': {
					'action': 'url:/rackdevice/clone'
				}
			}
		}
	},

	//=========================================================================
	// RACKSPARE
	//=========================================================================
	'rackspare': {
		'model': 'RackSpareSearch',
		'list': {
			'buttons': {
				'create': 'main/create'
			},
			'column_id': 'spare_id',
			'filters': {
				'select': {
					'datacenter_id': 'datacenter/datacenter'
				}
			},
			'columns': {
				'spare_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.spare_id ? '/rackspare/view/' + row.spare_id : ''
				},
				'datacenter_name': {
					'sort': true,
					'style-col': 'width: 200px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.datacenter_id ? '/datacenter/view/' + row.datacenter_id : '',
					'component-param-flagicon': (row) => 'flag-icon-' + String(row['datacenter_country'])
				},
				'spare_count': {
					'sort': true,
					'style-col': 'width: 90px'
				}
			},
			'opers': {
				'update': {
					'action': 'url:/rackspare/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'spare_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:rackspare:log_sub'
				}
			}
		}
	},

	//=========================================================================
	// RACKSERVICE
	//=========================================================================
	'rackservice': {
		'model': 'RackServiceSearch',
		'list': {
			'buttons': {
				'create': 'main/create'
			},
			'column_id': 'service_id',
			'filters': {
				'radio': {
					'service_type': 'main/type'
				},
				'select': {
					'datacenter_id': 'datacenter/datacenter'
				}
			},
			'columns': {
				'service_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.service_id ? '/rackservice/view/' + row.service_id : ''
				},
				'datacenter_name': {
					'sort': true,
					'style-col': 'width: 200px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.datacenter_id ? '/datacenter/view/' + row.datacenter_id : '',
					'component-param-flagicon': (row) => 'flag-icon-' + String(row['datacenter_country'])
				},
				'service_type': {
					'sort': true,
					'style-col': 'width: 150px',
					'function-row': (row, raw) => Helper.cellValueFromList('service_type', row, raw, ['ftc']),
					'function-cell-class': () => 'w5-breaked-text'
				},
				'service_price': {
					'sort': true,
					'style-col': 'width: 80px'
				}
			},
			'opers': {
				'update': {
					'action': 'url:/rackservice/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:rackservice:log_sub'
				}
			}
		}
	},

	//=========================================================================
	// Массив размеров страниц
	//=========================================================================
	'pageSizes': [10, 20, 50, 100, 500, 1000]

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
export default adminData
///////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// ./src/store/admin.js